import React, {memo} from 'react'
import {Toast as BaseToast} from 'bootstrap'
import {useRef, useState, useEffect} from 'hooks'
import {cn} from 'utils'

export default function Toast({close, unmount, isOpen, heading, body, debug, className, animation=true, autohide=true, delay=5000}: any)
{
	const [toast, setToast] = useState<any>()
	const toastRef = useRef<any>(undefined)
	const toastStateRef = useRef<any>(undefined)

	toastStateRef.current = toast

  useEffect(() => {
  	console.log('Mounted toast')
    if (toastRef.current) {
      setToast(new BaseToast(toastRef.current, {
      	animation,
      	autohide,
      	delay
      }))

      toastRef.current.addEventListener('hidden.bs.toast', unmount)
    }

    //return () => toastStateRef.current.dispose()
    return () => console.log('Unmounted toast')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
  	if (toast) {
  		isOpen
  			? toast.show()
  			: toast.hide()
  	}
  }, [isOpen, toast])


	return (
		<div ref={toastRef} className={cn('toast', 'align-items-center')} role="alert" aria-live="assertive" aria-atomic="true">
		  {heading && (
		  	<div className={cn('toast-header')}>
		  		{heading}
		  	</div>
		  )}
		  <div className="d-flex">
		    <div className="toast-body">
		      {body}
		    </div>
		    <button
		    	type="button"
		    	className="btn-close btn-close-white me-2 m-auto"
		    	aria-label="Close"
		    	onClick={() => close()}
		    />
		  </div>
		  {debug && (
		    <div className="toast-body">
		      <pre>{debug}</pre>
		    </div>
		  )}
		</div>
	)
}

export const InfoToast = memo((props: any) => {
	return (
		<Toast
			{...props}
			className="text-white bg-info"
		/>
	)
}, (props, nextProps) => {
	console.log({props, nextProps})
	return true
})

export const ErrorToast = memo((props: any) => {
	return (
		<Toast
			{...props}
			className="text-white bg-danger"
		/>
	)
}, (props, nextProps) => {
	console.log({props, nextProps})
	return true
})
